export const GENERAL = 'GENERAL';
export const TAB_BACKGROUNDED = 'TAB_BACKGROUNDED';
